import { Component} from '@angular/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-dailyreport',
  templateUrl: './dailyreport.component.html',
  styleUrls: ['./dailyreport.component.scss'],
})
export class DailyreportComponent {
  loader:boolean=true;
  trackerObj=[];
  dateFormat;
  startdate;
  enddate;
  id;
  items:any=[]; 
  tDate;
  fDate;
  days=['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  custName;
  close:boolean = false;
  url;

  constructor(private service: ApiService,public handler: HandlerService,public router: Router,public translate: TranslateService,
    public auth: AuthService,  public location: LocationService, private bottomSheet: MatBottomSheet) { }
    ionViewWillEnter(){
      this.trackerObj=[];   
      this.loader=true; 
      this.url = window.location.href;
      this.id = this.url.split('/').pop();  
      var date = new Date();
      this.dateFormat = this.auth.getDateformat();
      this.startdate = new Date(date.getFullYear(), date.getMonth(), 1);
      this.enddate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.getSubscription();
    
    }


    getSubscription(){
      this.loader=true;
     var start = this.returnDate(this.startdate) + ' ' + '00:00:00';
      var end = this.returnDate(this.enddate) + ' ' + '23:59:59';
     this.service.customerMonthlyTracker(this.id,start,end).subscribe((res:any)=>{
          if(res){
            this.items = res;
            this.items.map(res=>{
              this.trackerObj.push(res.singleServicesTracker)
            })         
            this.trackerObj.map(res1=>{
             Object.assign(res1,{clicked: false,cusName:res1[0].custName,packId:res1[0].packageId,street:res1[0].street,flatName:res1[0].flatName})
             res1.map(res2=>{
              res2.serviceTracker.sort((a, b) => new Date(a.apptDate).getTime() - new Date(b.apptDate).getTime());
            })
            })       
               
           setTimeout(() => {
            this.loader=false;
           }, 5000);
           
          }else{
            this.trackerObj=[];
            this.loader=false;
            this.handler.res('No Data Found')
          }
          },
        err=>{
          this.loader = false;
          this.handler.err(err)
        }) 
  
    }
 

    returnDate1(data){
      if(data.apptDate){
        var x  = data.apptDate.split("T");
        var y = x[0].split("-");
        var z = y[2]
        return z
      }
    }

    getDayName(data){
      var d = new Date(data.apptDate);
      var dayName = this.days[d.getDay()];
      return dayName
    }

  startDate(){
    this.enddate = "";
    this.fDate=this.returnDate(this.startdate);
  }

  endDate(){
    this.loader = true;
    var start = this.returnDate(this.startdate) + ' ' + '00:00:00';
    var end = this.returnDate(this.enddate) + ' ' + '23:59:59';
    this.trackerObj=[];
   
  }
  
  returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
   let month = data.getMonth() + 1;
   month = month < 10 ? '0' + month : month;
   let year = data.getFullYear();
   return year + '-' + month + '-' + date;
 }


ionViewWillLeave(){
  this.trackerObj=[]
  this.custName="";
  this.close=false;
}


}
